import publicUrl from './publicUrl';



export default publicUrl(({ spaceKey = ':spaceKey' }) => `/${spaceKey}/dashboard`);
